/* import __COLOCATED_TEMPLATE__ from './filter-panel.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import templateOnlyComponent from '@ember/component/template-only';
import type { ProjectedConversationsRanking } from 'embercom/lib/suggestions/constants';

interface Signature {
  Args: {
    localReasonTypes: string[];
    localDateRange: string;
    localTopics: string[];
    localImpactFilter: ProjectedConversationsRanking[];
    handleRangeFilter: (value: string) => void;
    handleReasonFilter: (value: string) => void;
    handleTopicFilter: (value: string) => void;
    handleImpactFilter: (value: ProjectedConversationsRanking | 'all') => void;
    handleApplyFilters: () => void;
    predictedSuggestionsCount: number;
    clearFilters: () => void;
    closeFilterPanel: () => void;
    clearButtonDisabled: boolean;
  };
}

const FilterPanel = templateOnlyComponent<Signature>();
export default FilterPanel;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::FilterPanel': typeof FilterPanel;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/filter-panel': typeof FilterPanel;
  }
}
